import { UseMutationOptions } from '@tanstack/react-query';

import useMutation from 'hooks/useMutation';
import { CuredApiPaths } from 'models/enums';

import MutationKeys from './keys';
import { MigrationSource } from './useParseMigrateTemplate';

export type SaveImportMappingsInput = {
    source: MigrationSource;
    tagMapping: Record<string, string>;
    conditionFieldMapping: Record<string, string>;
};

const useSaveImportMappings = (mutateOptions?: UseMutationOptions<unknown, Error, SaveImportMappingsInput>) =>
    useMutation<SaveImportMappingsInput>(
        MutationKeys.SAVE_IMPORT_MAPPINGS,
        CuredApiPaths.TEMPLATES_MIGRATE_MAPPINGS,
        mutateOptions
    );

export default useSaveImportMappings;
